import React from 'react';
import FormField from '../../components/Common/FormField';

const Vrate = (props) => {
  return (
    <FormField
      name={props.name}
      className="inner form-control"
      placeholder={props.placeholder}
      type="text"
      validate={{required: {value: true}}}
      errorMessage="Please provide a valid V.Rating."
    />
  );
};

export default Vrate;
